
import Title from '~/components/common/page-title.vue'

export default {
  name: 'RecruitKv',
  components: {
    Title
  }
}
